import styles from "@/styles/login.module.scss"
import Head from "next/head"
import LoginLayout from "@/components/LoginLayout"
import LoginForm from "@/components/login/LoginForm"
import RegisterForm from "@/components/login/RegisterForm"
import { useRouter } from "next/router";
import { useState, useEffect } from "react"
import { GoogleOAuthProvider } from '@react-oauth/google';

export default function PageLogin() {
  const router = useRouter();

  const [isLogin, setIsLogin] = useState(true)
  const [redirectUrl, setRedirectUrl] = useState('')

  // 切换登录/注册
  const handleSwitchType = async (type: string) => {
    if (type == 'login') {
      setIsLogin(true)
    } else if (type == 'register') {
      setIsLogin(false)
    }
  }

  // 登录、注册成功，返回前页面
  const pageReturn = () => {
    if (redirectUrl) {
      router.replace(redirectUrl);
    } else {
      router.replace('/');
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(router.asPath.split('?')[1]);
    const redirect = params.get('redirect');
    const type = params.get('type');

    // 存贮重定向地址
    if (redirect) {
      setRedirectUrl(redirect)
    }

    // 设置展示登录/注册页面
    if (type == 'register') {
      setIsLogin(false)
    }

    // 有token就认定为已经登录，立即跳转回去
    if (localStorage.getItem('userToken')) {
      pageReturn()
    }
  }, [])

  const [clientId, setClientId] = useState('');

  useEffect(() => {
    const hostname = window.location.hostname;
    let clientId;

    if (hostname === 'www.bestdeals.co.nz') {
      clientId = '643230432397-apfb6u4vrmbseu3kfmpkvgmmskd2ijfq.apps.googleusercontent.com';
    } else {
      clientId = '869604273014-bltm2mmquefd98qun9l0rqpe6c4mkjbr.apps.googleusercontent.com';
    }

    setClientId(clientId);
  }, []);

  if (!clientId) return null; // Wait for clientId to be set

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Head>
        <title>
          Online Shopping in New Zealand: Discount Store - BestDeals.co.nz
        </title>
        <meta
          name="keywords"
          content=""
        ></meta>
        <meta 
          name="description" 
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <LoginLayout>
        <div className={styles['page-login']}>
          {
            isLogin
            ?
            <LoginForm 
              onSwitchType={handleSwitchType}
              onSuccessJump={pageReturn}></LoginForm>
            :
            <RegisterForm 
              onSwitchType={handleSwitchType}
              onSuccessJump={pageReturn}></RegisterForm>
          }
        </div>
      </LoginLayout>
    </GoogleOAuthProvider>
  )
}